import { StoredImage } from "../../types";

// Same image-preview convention as every legacy *Edit page: a saved record
// stores the filename as a plain string, so wrap it into the shape
// ImageInput/ImageField expect for display; a freshly picked file already
// has that shape (from react-admin's own FileInput transform) and passes
// through unchanged.
export const formatImage = (value: StoredImage) => {
  if (!value) return [];
  if (typeof value === "string")
    return [
      {
        src: `${window["location"]["protocol"]}//${window["env"]["apiDomain"]}/uploads/${value}`,
      },
    ];
  return value;
};
